import { isDev } from "shared/util/EnvironmentHelpers";

/**
 * Gets the root URL for composing image URLs.
 * @returns {string} The resizer path at which images are served.
 */
export default function getImageResizerPath() {
	return !isDev
		? "https://cdn.okccdn.com/php/load_okc_image.php/images"
		: "https://imgsrv.dev.okcupid.com/php/resizer/load_okc_image.php/images";
}



// WEBPACK FOOTER //
// ./src/shared/util/getImageResizerPath.js